export default __webpack_public_path__ + "img/18dd7a7f92f98d895c52279512213498.png";